import { render, staticRenderFns } from "./income.vue?vue&type=template&id=451d452b&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports